import React from 'react';

// Título grande de la pantalla del asistente, con la fecha (y el nombre del
// inspector en PIN). El header de la app (EncabezadoApp, el común de VLS) lo
// monta cada pantalla FUERA de su contenedor angosto (max-w-xl): es sticky y
// va a todo el ancho, como en el resto de la app.
//   PIN: sin menú, solo "Salir" (la cuenta técnica no ve nada más).
//   SSO y kiosco: el menú de su rol (Estado, Inspecciones, Hallazgos…).
export default function EncabezadoAsistente({ titulo = 'Inspección diaria', subtitulo }) {
  return (
    <div className="pt-6 md:pt-8">
      <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground">{titulo}</h1>
      {subtitulo ? <p className="mt-1 text-sm text-muted-foreground">{subtitulo}</p> : null}
    </div>
  );
}
